import dayjs from "dayjs";

export default (time: Date | number) => dayjs(time).format("D MMM YYYY, HH:mm:ss");
